module.exports = __webpack_public_path__ + "img/nier.jpg.b2c8bd44.webp";